export default __webpack_public_path__ + "static/media/therapy_brain_health.cacd2b3d.webp";